<template>
  <!-- 5.缴费 -->
  <div>
    <div class="flex-x-y-center">
      <div class="profile-content">
        <div v-show="process.content.pay_switch === 0">
          <div class="iconfont icon-jinhangzhong flex-x-y-center advisement-icon"></div>
          <div class="title flex-x-y-center">待缴费</div>
        </div>
        <div v-show="process.content.pay_switch === 1">
          <div class="iconfont icon-tongguo flex-x-y-center pass-icon"></div>
          <div class="title flex-x-y-center">已缴费，您已完成报名！</div>
        </div>
        
        
        <div class="flex-x-center" >
          <div v-show="process.enable == 1" class="flex-x-center agree-sign-next">
          <button class="next-step " @click="toPay()" v-show="process.content.pay_switch === 0">
            去支付
          </button>
          <button class="next-step" @click="$parent.next()" v-show="process.content.pay_switch === 1">
            下一步
          </button>
        </div>
        </div>
        <div class="flex-x-center" >
          <div class="goodsnotice">
            提示：请需要购买复习资料的同学自行前往“书籍订购”菜单进行选购。
          </div>
        </div>
        <div class="inner-box">
          <div class="sill"></div>
          <el-table :data="[process.content]" style="width: 100%">
            <el-table-column prop="point" label="报名点" width="180">
            </el-table-column>
            <el-table-column prop="area" label="考区" width="180">
            </el-table-column>
            <el-table-column prop="grade" label="报考级别"> </el-table-column>
            <el-table-column prop="major" label="专业"> </el-table-column>
            <el-table-column prop="major" label="科目信息">
              <div v-for="(item, index) in process.content.subject" :key="index">
                {{ item.label }}
              </div>
            </el-table-column>
            <el-table-column prop="money" label="总金额"> </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <el-dialog title="是否已完成支付" :visible.sync="jfVisiblePay" width="30%" :before-close="handleClose">
      <span>请在请打开的页面中完成支付</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="jfVisiblePay = false">取消支付</el-button>
        <el-button type="primary" @click="checkPayResult($parent.projectDetail.project_info.id)">已完成支付</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { reqApplyPayResult } from "@/api";
export default {
  data() {
    return {
      jfVisiblePay: false,
    };
  },
  props: {
    // 流程
    process_index: 0,
    process: {
      type: Object,
      default() {
        return [];
      },
    },
  },
  methods: {
    checkPayResult(project_id) {
      reqApplyPayResult(project_id).then((res) => {
        if (res.data.code === 1) {
          this.$message.success(res.data.msg);
          this.jfVisiblePay = false;
          this.$parent.reload();
          //调用父组件，进入下一步
        }
      });
    },
    toPay() {
      console.log(this.process);
      window.open(this.process.content.pay_url);
      this.jfVisiblePay = true;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => { });
    },
  },
};
</script>

<style scoped>
.unpassd-icono {
  font-size: 60px;
  color: #b8000d;
}

.advisement-icon {
  font-size: 60px;
  color: rgb(37, 110, 206);
}

.pass-icon {
  font-size: 60px;
  color: rgb(50, 187, 62);
}

.inner-box {
  margin-top: 30px;
}

.title {
  margin-top: 10px;
  padding-top: 0px;
}

.three-box {
  width: 80%;
  height: 300px;
  /* background-color: rgb(149, 121, 226); */
  margin-top: 40px;
  border: rgb(231, 225, 225) 1px solid;
  border-radius: 4px;
}
.goodsnotice {
  color: #b8000d;
    font-weight: 600;
    font-size: 18px;
    text-align: center;
    margin-top: 10px;
}
</style>
